// ---------- Modo claro / oscuro ----------
// null = "sigue al celular" (prefers-color-scheme, sin elección explícita).
// "light" | "dark" = el usuario lo forzó manualmente, gana sobre el sistema.
const THEME_KEY = "ts_theme";

export function getStoredTheme() {
  const v = localStorage.getItem(THEME_KEY);
  return v === "light" || v === "dark" ? v : null;
}

export function getSystemTheme() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
}

export function getEffectiveTheme() {
  return getStoredTheme() || getSystemTheme();
}

function applyThemeAttribute(theme) {
  if (theme) {
    document.documentElement.setAttribute("data-theme", theme);
  } else {
    document.documentElement.removeAttribute("data-theme");
  }
}

// Fuerza un tema (o null para volver a "sigue al celular") y lo recuerda.
export function setTheme(theme) {
  if (theme === null) {
    localStorage.removeItem(THEME_KEY);
  } else {
    localStorage.setItem(THEME_KEY, theme);
  }
  applyThemeAttribute(theme);
}

// Se llama una vez al cargar la app: aplica lo guardado (si el usuario ya
// eligió) y, si no, deja que solo la media query decida — y sigue
// escuchando por si el sistema operativo cambia de tema mientras la app
// sigue abierta (nunca si el usuario ya forzó uno manualmente).
export function initTheme() {
  const stored = getStoredTheme();
  applyThemeAttribute(stored);
  if (!stored && window.matchMedia) {
    const mq = window.matchMedia("(prefers-color-scheme: light)");
    const onChange = () => { if (!getStoredTheme()) applyThemeAttribute(null); };
    mq.addEventListener ? mq.addEventListener("change", onChange) : mq.addListener(onChange);
  }
}

// Paleta rápida ofrecida al elegir color primario/secundario — compartida
// entre las pantallas de marca (agencia y master) para no repetirla.
export const PRESET_COLORS = ["#004AAD", "#FF85AC", "#FF7A1A", "#F4B400", "#21D07A", "#E0497F", "#8C5BFF", "#FF3B30"];

// Elige texto negro o blanco según qué tanto contraste da sobre un color de
// fondo — así un cuadro con el color secundario de la agencia (que puede ser
// claro u oscuro, lo elige cada agencia) nunca se traga el texto encima.
export function getContrastText(hex) {
  const clean = (hex || "").replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(clean)) return "#ffffff";
  const r = parseInt(clean.slice(0, 2), 16) / 255;
  const g = parseInt(clean.slice(2, 4), 16) / 255;
  const b = parseInt(clean.slice(4, 6), 16) / 255;
  const lin = (c) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4));
  const luminance = 0.2126 * lin(r) + 0.7152 * lin(g) + 0.0722 * lin(b);
  return luminance > 0.45 ? "#0A0A0A" : "#ffffff";
}
